import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import app from "./app";
import auth from "./auth";
import betSlip from "./betSlip";
import game from "./game";
import siteSearch from "./siteSearch";
import sound from "./sound";
import sportPrefs from "./sportPrefs";

const betSlipPersistConfig = {
  key: "betSlip",
  storage,
  blacklist: ["isOpen"],
};

const reducer = combineReducers({
  app,
  auth,
  betSlip: persistReducer(betSlipPersistConfig, betSlip),
  game,
  siteSearch,
  sound,
  sportPrefs: persistReducer({ key: "sportPrefs", storage }, sportPrefs),
});

export default reducer;
